export interface BrandKitsEmptyStateBoxProps {
    emptyMessageType: BrandKitsEmptyMessageType;
    canUserAccessBrandKits: boolean;
    className?: string;
    textClassName?: string;
    ctaClassName?: string;
}

export enum BrandKitsEmptyMessageType {
    NO_BRAND_KITS = 'noBK',
    INCOMPLETE_BRAND_KITS = 'incompleteBK'
}